import { render, staticRenderFns } from "./pagTools.vue?vue&type=template&id=ce8082de&scoped=true"
import script from "./pagTools.vue?vue&type=script&lang=js"
export * from "./pagTools.vue?vue&type=script&lang=js"
import style0 from "./pagTools.vue?vue&type=style&index=0&id=ce8082de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8082de",
  null
  
)

export default component.exports